var _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 19,
    height: 19,
    transform: "rotate(-180 20 24)",
    stroke: "black",
    strokeWidth: 1.60714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6424 7.15625L35.0312 14.5781M35.0312 14.5781L27.6424 22M35.0312 14.5781L19 14.5781",
    stroke: "black",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M8.78613 13.0391H10.1396C10.7842 13.0391 11.2617 12.8779 11.5723 12.5557C11.8828 12.2334 12.0381 11.8057 12.0381 11.2725C12.0381 10.7568 11.8828 10.3555 11.5723 10.0684C11.2676 9.78125 10.8457 9.6377 10.3066 9.6377C9.82031 9.6377 9.41309 9.77246 9.08496 10.042C8.75684 10.3057 8.59277 10.6514 8.59277 11.0791H6.05273C6.05273 10.4111 6.23145 9.81348 6.58887 9.28613C6.95215 8.75293 7.45605 8.33692 8.10059 8.03809C8.75098 7.73926 9.46582 7.58985 10.2451 7.58985C11.5986 7.58985 12.6592 7.91504 13.4268 8.56543C14.1943 9.20996 14.5781 10.1006 14.5781 11.2373C14.5781 11.8232 14.3994 12.3623 14.042 12.8545C13.6846 13.3467 13.2158 13.7246 12.6357 13.9883C13.3564 14.2461 13.8926 14.6328 14.2441 15.1484C14.6016 15.6641 14.7803 16.2734 14.7803 16.9766C14.7803 18.1133 14.3643 19.0244 13.5322 19.71C12.7061 20.3955 11.6104 20.7383 10.2451 20.7383C8.96777 20.7383 7.92188 20.4014 7.10742 19.7275C6.29883 19.0537 5.89453 18.1631 5.89453 17.0557H8.43457C8.43457 17.5361 8.61328 17.9287 8.9707 18.2334C9.33398 18.5381 9.7793 18.6904 10.3066 18.6904C10.9102 18.6904 11.3818 18.5322 11.7217 18.2158C12.0674 17.8936 12.2402 17.4688 12.2402 16.9414C12.2402 15.6641 11.5371 15.0254 10.1309 15.0254H8.78613V13.0391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward3);
export default __webpack_public_path__ + "static/media/Forward3.a417920392098e3c329943b2e11ba75c.svg";
export { ForwardRef as ReactComponent };